<script setup>
import { computed, inject } from "vue";
import { usePage } from "@inertiajs/vue3";
import { useI18n } from "vue-i18n";

const route = inject("route");
const { t } = useI18n();
</script>

<template>
  <div class="relative w-full h-screen flex items-center justify-start">
    <!-- Image as the background with <img> tag -->
    <img
      src="@/../img/home/doctor-1.png"
      alt="Background"
      class="absolute w-full h-full object-cover rounded-lg shadow-lg"
    />

    <!-- Black Overlay covering full screen -->
    <div class="absolute inset-0 bg-black bg-opacity-80"></div>

    <!-- Content Box (Left-Aligned & Full Height) -->
    <div class="section-container">
      <div
        class="relative z-10 flex flex-col justify-center items-start w-full text-left text-white h-full px-10"
      >
        <h1
          class="text-4xl md:text-5xl text-white"
        >{{ $t('Het platform voor flexibel werken in de zorg') }}</h1>
        <p
          class="mt-5 text-lg md:text-xl font-semibold text-white"
        >{{ $t('Zorgblik verbindt zorgorganisaties snel en flexibel met gekwalificeerde zorgprofessionals. Onze digitale oplossing zorgt voor de juiste match op het juiste moment, zodat u zich kunt focussen op waar het écht om gaat: uitstekende zorg bieden.') }}</p>

        <div
          class="mt-5 text-lg md:text-xl text-white"
        >{{ $t('Bepaal zelf waar en wanneer je werkt') }}</div>
        <div
          class="mt-5 text-lg md:text-xl text-white"
        >{{ $t('Claim eenvoudig een dienst via de app') }}</div>
        <button
          class="bg-[#437066] text-white px-6 py-3 rounded-lg text-lg md:text-xl font-semibold hover:bg-[#355a50] transition mt-4"
        >{{ $t('Direct aanmelden') }}</button>
      </div>
    </div>
  </div>
</template>
